/* eslint-disable react-hooks/exhaustive-deps */
import { message } from "antd";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { createStructuredSelector } from "reselect";

import {
  selectErrorMsg,
  selectSuccessMsg,
} from "../../redux/common/common.selectors";
import { setErrorMsg, setSuccessMsg } from "../../redux/common/common.actions";
import { Outlet } from "react-router";

const Toast: React.FC = (props: any) => {
  const { isError, isSuccess, setSuccessMsg, setErrorMsg } = props;
  const [messageApi, contextHolder] = message.useMessage();
  useEffect(() => {
    if (isError) {
      messageApi.error(isError);
      setTimeout(() => {
        setErrorMsg("");
      }, 2000);
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      messageApi.success(isSuccess);
      setTimeout(() => {
        setSuccessMsg("");
      }, 2000);
    }
  }, [isSuccess]);

  return (
    <>
      {contextHolder}
      <Outlet />
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  isError: selectErrorMsg,
  isSuccess: selectSuccessMsg,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSuccessMsg: (value: string) => dispatch(setSuccessMsg(value)),
    setErrorMsg: (value: string) => dispatch(setErrorMsg(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Toast);
